var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6478 2.67419L13.1526 8.24105L14.5386 4.95668L20.6478 2.67419Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34464 2.67419L10.7797 8.29378L9.4614 4.95668L3.34464 2.67419Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.951 15.5781L15.9548 18.6365L20.226 19.8116L21.4539 15.6459L17.951 15.5781Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55368 15.6459L3.77402 19.8116L8.04521 18.6365L6.04897 15.5781L2.55368 15.6459Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80416 10.4105L6.61395 12.2109L10.855 12.3992L10.7043 7.8418L7.80416 10.4105Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1883 10.4105L13.2505 7.78906L13.1526 12.3992L17.3861 12.2109L16.1883 10.4105Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0452 18.6365L10.5913 17.3936L8.39171 15.6761L8.0452 18.6365Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4011 17.3936L15.9548 18.6365L15.6007 15.6761L13.4011 17.3936Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9548 18.6366L13.4011 17.3936L13.6045 19.0584L13.5819 19.759L15.9548 18.6366Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0452 18.6366L10.4181 19.759L10.403 19.0584L10.5913 17.3936L8.0452 18.6366Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4557 14.5763L8.33145 13.9511L9.83051 13.2656L10.4557 14.5763Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5367 14.5763L14.1619 13.2656L15.6685 13.9511L13.5367 14.5763Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04519 18.6366L8.40677 15.5782L6.04895 15.646L8.04519 18.6366Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5932 15.5782L15.9548 18.6366L17.951 15.646L15.5932 15.5782Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7459 12.8734L13.8661 12.868C13.8276 12.8974 13.793 12.9326 13.7638 12.9731L13.7459 12.8734ZM14.4463 12.8422L16.1387 12.7669L15.5647 13.351L14.4463 12.8422Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86529 12.767L9.56096 12.8423L8.44209 13.3514L7.86529 12.767ZM10.2597 12.8733L10.2419 12.9706C10.2131 12.9311 10.1792 12.8968 10.1415 12.8681L10.2597 12.8733Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61392 12.2109L8.3917 15.6761L8.33144 13.951L6.61392 12.2109Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6761 13.951L15.6007 15.6761L17.386 12.2109L15.6761 13.951Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.855 12.3993L10.4557 14.5763L10.9529 17.1451L11.0659 13.7628L10.855 12.3993Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1525 12.3993L12.9491 13.7552L13.0395 17.1451L13.5442 14.5763L13.1525 12.3993Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5443 14.5763L13.0396 17.145L13.4011 17.3936L15.6008 15.6761L15.6761 13.951L13.5443 14.5763Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33145 13.951L8.39172 15.6761L10.5913 17.3936L10.9529 17.145L10.4557 14.5763L8.33145 13.951Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5819 19.759L13.6045 19.0584L13.4162 18.8927H10.5763L10.403 19.0584L10.4181 19.759L8.0452 18.6365L8.87382 19.3145L10.5537 20.4821H13.4388L15.1262 19.3145L15.9548 18.6365L13.5819 19.759Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4011 17.3936L13.0396 17.145H10.9529L10.5913 17.3936L10.403 19.0584L10.5763 18.8927H13.4162L13.6045 19.0584L13.4011 17.3936Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9642 8.60263L21.6045 5.52919L20.6478 2.67419L13.4011 8.05273L16.1883 10.4105L20.1281 11.5631L21.0019 10.5461L20.6252 10.2749L21.2279 9.72504L20.7608 9.36346L21.3635 8.90395L20.9642 8.60263Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39548 5.52919L3.03578 8.60263L2.629 8.90395L3.23164 9.36346L2.77213 9.72504L3.37476 10.2749L2.99811 10.5461L3.8644 11.5631L7.80414 10.4105L10.5913 8.05273L3.34463 2.67419L2.39548 5.52919Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1281 11.5631L16.1883 10.4105L17.3861 12.2109L15.6008 15.6761L17.9511 15.6459H21.4539L20.1281 11.5631Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80415 10.4105L3.86441 11.5631L2.55368 15.6459H6.04897L8.39172 15.6761L6.61394 12.2109L7.80415 10.4105Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1525 12.3992L13.4011 8.05271L14.5461 4.95667H9.4614L10.5913 8.05271L10.855 12.3992L10.9454 13.7702L10.9529 17.145H13.0395L13.0546 13.7702L13.1525 12.3992Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.77e7040ebe1871eeb2558803256aa75f.svg";
export { ForwardRef as ReactComponent };